module.exports = __webpack_public_path__ + "static/media/paquay-summer-tasting-1600x1600.c6074583.jpg";